import { CALYPSO_MEDIUM, LORAX, LORAX_LIGHT, OBSIDIAN, OLAF } from 'HubStyleTokens/colors';
import { WEB_FONT_BOLD_WEIGHT } from 'HubStyleTokens/misc';
import UIBanner from 'UIComponents/alert/UIBanner';
import { H5 } from 'UIComponents/elements/headings';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIBox from 'UIComponents/layout/UIBox';
import UIFlex from 'UIComponents/layout/UIFlex';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  displayName: "DefaultBanner__Container",
  componentId: "sc-16it140-0"
})(["display:flex;justify-content:center;align-items:center;padding:8px 16px;background:", ";"], LORAX_LIGHT);
const Title = styled.span.withConfig({
  displayName: "DefaultBanner__Title",
  componentId: "sc-16it140-1"
})(["font-weight:700;"]);
const DefaultBanner = ({
  button,
  titleText,
  subtext,
  isUngatedUpgradeBannerRedesign2024,
  closeable,
  dataTestId,
  className,
  style = {}
}) => {
  if (isUngatedUpgradeBannerRedesign2024) {
    return /*#__PURE__*/_jsxs(Container, {
      className: className,
      "data-test-id": dataTestId,
      style: style,
      children: [/*#__PURE__*/_jsx(UIIcon, {
        className: "m-right-3",
        size: 24,
        name: "upgrade",
        color: LORAX
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx(Title, {
          children: titleText
        }), "\xA0", subtext, "\xA0", button]
      })]
    });
  }
  const bannerStyle = Object.assign({}, style, {
    color: OBSIDIAN,
    background: OLAF,
    minHeight: '72px',
    border: `1px solid ${CALYPSO_MEDIUM}`,
    borderRadius: '5px'
  });
  return /*#__PURE__*/_jsx(UIBanner, {
    className: className,
    closeable: closeable,
    "data-test-id": dataTestId,
    style: bannerStyle,
    children: /*#__PURE__*/_jsxs(UIFlex, {
      className: "p-y-3",
      wrap: "wrap",
      align: "center",
      style: {
        gap: '16px 0'
      },
      children: [/*#__PURE__*/_jsxs(UIBox, {
        basis: 250,
        grow: 100,
        className: "flex-wrap align-center",
        style: {
          gap: '8px 0'
        },
        children: [/*#__PURE__*/_jsxs(UIBox, {
          className: "m-right-4 align-center",
          style: {
            lineHeight: 1
          },
          children: [/*#__PURE__*/_jsx(UIIcon, {
            className: "m-right-3",
            size: 24,
            name: "upgrade",
            color: LORAX,
            style: {
              marginTop: '1px'
            }
          }), /*#__PURE__*/_jsx(H5, {
            style: {
              fontWeight: WEB_FONT_BOLD_WEIGHT,
              lineHeight: 1
            },
            className: "m-bottom-0",
            children: titleText
          })]
        }), /*#__PURE__*/_jsx(UIBox, {
          children: subtext
        })]
      }), /*#__PURE__*/_jsx(UIBox, {
        basis: 110,
        className: "m-left-1",
        children: button
      })]
    })
  });
};
export default DefaultBanner;